import { Skeleton } from 'antd';
import styled from 'styled-components';

export const PaddedSkeleton = styled(Skeleton)`
  padding: 16px;
`;
